module.exports = __webpack_public_path__ + "static/media/baseline-local_cafe-24px.b08ad18f.svg";